"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = exports.StyledTableHead = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _defaultTheme = _interopRequireDefault(require("../../defaultTheme"));
var _TableCell = require("../TableCell");
const StyledTableHead = (0, _styledComponents.default)(({
  children,
  className,
  dataTest
}) => /*#__PURE__*/React.createElement("thead", {
  className: className,
  "data-test": dataTest
}, children)).withConfig({
  displayName: "TableHead__StyledTableHead",
  componentId: "sc-ievcej-0"
})(["border-bottom:1px solid ", ";width:100%;white-space:nowrap;", "{font-weight:", ";}"], ({
  theme
}) => theme.orbit.borderColorTableHead, _TableCell.StyledTableCell, ({
  theme
}) => theme.orbit.fontWeightTableHead);
exports.StyledTableHead = StyledTableHead;
StyledTableHead.defaultProps = {
  theme: _defaultTheme.default
};
const TableHead = ({
  children,
  dataTest
}) => /*#__PURE__*/React.createElement(StyledTableHead, {
  dataTest: dataTest
}, children);
var _default = TableHead;
exports.default = _default;